import jQuery from "jquery";
import { Spinner } from "spin.js";

export default function initDonationBox() {
  (function ($) {
    function toggleBankLinks() {
      var disabledBankLinks = $(".js-regularPaymentDisabled");
      if ($(".js-regularPaymentToggle").is(":checked")) {
        $(disabledBankLinks).addClass("st-inactive");
        $(disabledBankLinks).click(function (e) {
          e.preventDefault();
        });
      } else {
        $(disabledBankLinks).removeClass("st-inactive");
      }
    }

    toggleBankLinks();
    $(".js-regularPaymentToggle").change(function () {
      toggleBankLinks();
    });

    function subscribeList() {
      if ($.trim($(".js-emailInputCollapse").val()) !== "") {
        var email = $(".js-emailInputCollapse").val();

        var control = "b_2b7484322bdea6a85b6b8afd7_b8e4ec738d";
        $.ajax({
          type: "POST",
          data: { EMAIL: email, control: "" },
          url: "//kingitudelu.us13.list-manage.com/subscribe/post?u=2b7484322bdea6a85b6b8afd7&amp;id=b8e4ec738d",
          cache: false,
        }).done(function () {});
      }
    }

    $(".js-standingOrderEnabled").click(function (e) {
      e.preventDefault();
      if ($(".js-regularPaymentToggle").is(":checked")) {
        subscribeList();
        var amount = $(".js-donationAmount").attr("placeholder");
        if ($(".js-donationAmount").val() > 0) {
          amount = $(".js-donationAmount").val();
        }
        var url = $(this).attr("data-standingOrderUrl") + amount;
        window.location.href = url;
      }
    });

    /* Loading spinner */
    var donationSpinnerOptions = {
      lines: 13,
      length: 28,
      width: 14,
      radius: 42,
      scale: 0.25,
      corners: 1,
      color: "#fff",
      opacity: 0.25,
      rotate: 0,
      direction: 1,
      speed: 1,
      trail: 60,
      fps: 20,
      zIndex: 2e9,
      className: "spinner",
      top: "50%",
      left: "50%",
      shadow: false,
      hwaccel: false,
      position: "absolute",
    };

    var donationSpinner = new Spinner(donationSpinnerOptions);

    $(".js-bankLinks a:not(.js-paypal)").click(function (e) {
      console.log("click");

      var $this = $(this);
      e.preventDefault();
      if ($(".js-regularPaymentToggle").is(":not(:checked)")) {
        subscribeList();

        var amount = $(".js-donationAmount").attr("placeholder");

        if ($(".js-donationAmount").val() > 0) {
          amount = $(".js-donationAmount").val();
        }

        var bankTag = $(this).attr("data-bank");
        var banklinkurl = $(this).attr("data-bankLinkUrl");

        console.log(bankTag);
        console.log(banklinkurl);
        console.log(amount);

        $.ajax({
          type: "POST",
          data: { payment: { custom_amount: amount }, bank: bankTag },
          url: banklinkurl,
          cache: false,
          beforeSend: function () {
            var donationSpinnerWrap = $(".donationBox .spinnerWrapper")[0];
            donationSpinner.spin(donationSpinnerWrap);
          },
          complete: function () {
            donationSpinner.stop();
          },
        }).done(function (html) {
          var $html = $(html);
          if (
            $this.attr("data-bank") === "nordea" ||
            $this.attr("data-bank") === "lhv" ||
            $this.attr("data-bank") === "coop" ||
            $this.attr("data-bank") === "seb" ||
            $this.attr("data-bank") === "swedbank"
          ) {
            var bankLinkForm = $("form", $html);
          } else {
            var bankLinkForms = $("form", $html);
            var bankFormIndex = { swed: 0, seb: 1, danske: 2 };
            bankLinkForm =
              bankLinkForms[bankFormIndex[$this.attr("data-bank")]];
          }
          if (bankLinkForm) {
            $("body").append(bankLinkForm);
            bankLinkForm.submit();
          }
        });
      }
    });

    $(".js-paypal").click(function (e) {
      e.preventDefault();
      subscribeList();
      /*
        var amount = $('.js-donationAmount').attr('placeholder');
        if ( $('.js-donationAmount').val() > 0 ) {
          amount = $('.js-donationAmount').val();
        }
        $('.js-paypalAmount').val(amount);
        */
      $(".js-paypalForm").submit();
    });

    /* JQuery UI tooltip in public mode */
    /*$.widget("ui.tooltip", $.ui.tooltip, {
    options: {
      content: function () {
        return $(this).prop('title');
      }
    }
  });*/

    /*$('.js-donationTooltipTogglePublic').attr('title', $('.js-donationTooltipContent').html());
  $('.js-donationTooltipTogglePublic').tooltip({
    tooltipClass: 'js-donationTooltipContent'
  });*/

    $(".js-donationTooltipToggleEdit").click(function (e) {
      //$('.js-donationTooltipContent').slideToggle();
      e.preventDefault();
    });

    $(".js-donationTooltipTogglePublic").hover(function (e) {
      $(".js-donationTooltipContent-public").toggleClass("hover");
    });

    // Input placeholders for IE. Taken from https://gist.github.com/hagenburger/379601
    // DISABLED 12.08.2024
    // placeholderSupport = "placeholder" in document.createElement("input");
    // if (!placeholderSupport) {
    //   $("[placeholder]")
    //     .focus(function () {
    //       var input = $(this);
    //       if (input.val() === input.attr("placeholder")) {
    //         input.val("");
    //         input.removeClass("placeholder");
    //       }
    //     })
    //     .blur(function () {
    //       var input = $(this);
    //       if (input.val() === "" || input.val() === input.attr("placeholder")) {
    //         input.addClass("placeholder");
    //         input.val(input.attr("placeholder"));
    //       }
    //     })
    //     .blur()
    //     .parents("form")
    //     .submit(function () {
    //       $(this)
    //         .find("[placeholder]")
    //         .each(function () {
    //           var input = $(this);
    //           if (input.val() === input.attr("placeholder")) {
    //             input.val("");
    //           }
    //         });
    //     });
    // }

    var subscriptionNote = "Subscription note";
    var subscriptionSent = "Subscription sent";

    $(".donationBox_emailSubmit").click(function () {
      if ($.trim($(".js-emailInputCollapse").val()) !== "") {
        subscribeList();
        $(".donationBox_emailText").text(subscriptionSent);
        //location.reload();
      } else {
        $(".donationBox_emailText").text(subscriptionNote);
      }
    });

    $(".donationBox_emailInput").keyup(function (e) {
      if (e.keyCode === 13) {
        if ($.trim($(".js-emailInputCollapse").val()) !== "") {
          subscribeList();
          $(".donationBox_emailText").text(subscriptionSent);
          //location.reload();
        } else {
          $(".donationBox_emailText").text(subscriptionNote);
        }
      }
    });

    $(".js-donationBox_button").click(function (e) {
      e.preventDefault();
      var buttonValue = $(this).text();
      console.log(buttonValue);
      $("#zlick_incoming_price").val(buttonValue).trigger("change");
    });
  })(jQuery);
}
